<div
  class="field-settings"
  (mouseenter)="handleExpandableState()"
  (mouseleave)="handleExpandableState()"
>
  <div class="settings-title">
    <i class="cc-icon cc-icon-gear sm-pr-1"></i>
    <span class="sm-text-default-text sm-font-sans">Field Settings</span>
  </div>

  <div *ngFor="let action of actions" class="sm-flex sm-items-center">
    <div *ngIf="action.isVisible" class="sm-flex sm-items-center sm-gap-1">
      <input
        type="checkbox"
        class="checkbox-input {{ isExpanded ? 'sm-ml-[2px]' : '' }}"
        [(ngModel)]="field[action.fieldName]"
        (change)="action.onUpdate.emit()"
        [id]="action.label + '-' + field.id"
      />
      <label [for]="action.label + '-' + field.id" class="checkbox-label">
        <i class="cc-icon cc-icon-{{ action.icon }}"></i>
        <span *ngIf="isExpanded">{{ action.label }}</span>
      </label>
    </div>
  </div>
</div>
